// eslint-disable-next-line no-shadow
export enum EHydraCreditMethod {
  creditNote = 'credit-note',
  standAlone = 'stand-alone',
}
